import React from "react";
import { useState } from "react";
import axios from "axios";
import RingLoader from "react-spinners/RingLoader";
import "../styles/Search.css";

import Main from "./Main";
import Table from "./Table";
import Forecast from "./Forecast";

export default function Search() {
  let [city, setCity] = useState("");
  let [weatherData, setWeatherData] = useState({});
  let [date, setDate] = useState("");
  let [time, setTime] = useState("");
  let [loading, setLoading] = useState(false);

  function onFormSubmit(event) {
    event.preventDefault();
    setLoading(false);

    let API_KEY = "e34d0t2732c4955489449b41af8fo3a4";
    let url = `https://api.shecodes.io/weather/v1/current?query=${city}&key=${API_KEY}&units=metric`;
    axios.get(url).then(getResponse);
  }

  function onCurrentBtnClick() {
    navigator.geolocation.getCurrentPosition(currentPosition);
  }

  function currentPosition(position) {
    let currentLat = position.coords.latitude;
    let currentLong = position.coords.longitude;
    setLoading(false);

    let API_KEY = "e34d0t2732c4955489449b41af8fo3a4";
    let url = `https://api.shecodes.io/weather/v1/current?lon=${currentLong}&lat=${currentLat}&key=${API_KEY}&units=metric`;
    axios.get(url).then(getResponse);
  }

  function updateCity(event) {
    setCity(event.target.value);
  }

  function getDateInfo(dt) {
    let date = new Date(dt * 1000);
    let days = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];
    let months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    return `${days[date.getDay()]}, ${date.getDate()} ${
      months[date.getMonth()]
    }`;
  }

  function getTimeInfo(dt) {
    let date = new Date(dt * 1000);
    let hours = date.getHours();
    let minutes = date.getMinutes();

    if (hours < 10) {
      hours = `0${hours}`;
    }
    if (minutes < 10) {
      minutes = `0${minutes}`;
    }

    return `${hours}:${minutes}`;
  }

  function getResponse(response) {
    setLoading(true);

    setWeatherData({
      cityname: response.data.city,
      country: response.data.country,
      lon: response.data.coordinates.longitude,
      lat: response.data.coordinates.latitude,
      img: response.data.condition.icon_url,
      description: response.data.condition.description,
      wind: Math.round(response.data.wind.speed),
      temperature: Math.round(response.data.temperature.current),
      humidity: response.data.temperature.humidity,
    });
    setDate(getDateInfo(response.data.time));
    setTime(getTimeInfo(response.data.time));
  }

  if (loading) {
    return (
      <div>
        <div className="Search">
          <div className="section">
            <form id="form-search" onSubmit={onFormSubmit}>
              <input
                className="form-control"
                type="search"
                onChange={updateCity}
                placeholder="Enter a city"
              />
              <button className="btn" type="submit">
                Search
              </button>
              <button
                className="btn"
                type="button"
                onClick={onCurrentBtnClick}
                id="btn-current"
              >
                Current
              </button>
            </form>
          </div>
        </div>
        <Main data={weatherData} date={date} time={time} />
        <Table data={weatherData} />
        <Forecast data={weatherData} />
      </div>
    );
  } else {
    return (
      <div className="Search">
        <div className="section">
          <form id="form-search" onSubmit={onFormSubmit}>
            <input
              className="form-control"
              type="search"
              onChange={updateCity}
              placeholder="Enter a city"
            />
            <button className="btn" type="submit">
              Search
            </button>
            <button
              className="btn"
              type="button"
              onClick={onCurrentBtnClick}
              id="btn-current"
            >
              Current
            </button>
          </form>
          <div className="spinner">
            <RingLoader
              color={"blue"}
              loading={true}
              size={45}
              aria-label="Loading Spinner"
              data-testid="loader"
              speedMultiplier={0.5}
            />
          </div>
        </div>
      </div>
    );
  }
}
